import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { ErrorTracking } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/error-tracking")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <ErrorTracking />
    </RouteGuard>
  ),
});
